import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';

const isPendingLazyloadImage = (target) =>
	target?.classList?.contains('lazyload') ||
	target?.classList?.contains('lazyloading');

const removeLazyloadSkeleton = ({ target, type }) => {
	if (!target?.closest) {
		return;
	}

	if ((type === 'load' || type === 'error') && isPendingLazyloadImage(target)) {
		return;
	}

	const wrapper = target.closest('.skeleton');

	if (!wrapper) {
		return;
	}

	wrapper.classList.remove('skeleton');
};

const removeLoadedLazyloadSkeletons = () => {
	document
		.querySelectorAll('.skeleton .lazyloaded, .skeleton .lazyerror')
		.forEach((image) => {
			removeLazyloadSkeleton({ target: image });
		});
};

document.addEventListener('lazyloaded', removeLazyloadSkeleton);
document.addEventListener('lazyerror', removeLazyloadSkeleton);
document.addEventListener('load', removeLazyloadSkeleton, true);
document.addEventListener('error', removeLazyloadSkeleton, true);
document.addEventListener('DOMContentLoaded', removeLoadedLazyloadSkeletons);
removeLoadedLazyloadSkeletons();
